/**
 * Scroll Down Module
 * Gestisce il comportamento sticky e click dell'icona scroll-down nell'hero
 */

import { $, addClass, removeClass } from '../utils/dom.js';

export const initScrollDown = () => {
  const hero = $('.hero--home') || $('.hero--full-image');
  if (!hero) return;

  const scrollDown = hero.querySelector('.scroll-down');
  if (!scrollDown) return;

  // Click handler per smooth scroll alla sezione successiva
  scrollDown.addEventListener('click', () => {
    const nextSection = hero.nextElementSibling;
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  });

  // Sticky behavior solo su schermi >= 1280px
  if (window.innerWidth < 1280) return;

  const heroHeight = hero.offsetHeight;
  const viewportHeight = window.innerHeight;

  // Solo se l'hero è più alto della viewport
  if (heroHeight <= viewportHeight) return;

  let ticking = false;
  const bottomOffset = 32;

  const updatePosition = () => {
    const heroRect = hero.getBoundingClientRect();

    // Fixed quando: il bottom dell'hero è sotto la posizione naturale dell'elemento
    if (heroRect.bottom > viewportHeight - bottomOffset) {
      addClass(scrollDown, 'scroll-down--fixed');
    } else {
      removeClass(scrollDown, 'scroll-down--fixed');
    }

    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(updatePosition);
      ticking = true;
    }
  });

  // Check iniziale
  updatePosition();
};
